<template>
  <div class="single-project-wrapper">
    <!-- loader for display while fetching -->
    <v-progress-linear
      class="project-loading-indicator"
      indeterminate
      color="secondary"
      v-if="isLoading"
    />

    <!-- failure notification -->
    <v-alert
      v-if="loadingHasFailed"
      class="single-project-load-fail-alert"
      type="error"
      elevation="2"
    >
      Failed to load data from Wordpress API
    </v-alert>

    <!-- project card  -->
    <ProjectCard v-if="!isLoading" :data="projectData" />
  </div>
</template>

<script>
import ProjectCard from "@/components/SingleProject/ProjectCard";
// import { getWorkItemBySlug } from '@/utils/wpApiUtils'
import { getWorkItemBySlug } from "@/utils/wpApiUtils";
export default {
  name: "SingleProjectPage",
  components: { ProjectCard },
  data() {
    return {
      projectData: null,
      isLoading: true,
      loadingHasFailed: false
    };
  },
  computed: {
    projectSlug() {
      return this.$route.params.slug;
    },
    acf() {
      if (!this.projectData) return null;
      return this.projectData.acf_data;
    }
  },
  mounted() {
    getWorkItemBySlug(this.projectSlug)
      .then(data => {
        this.projectData = data;
        this.isLoading = false;
      })
      .catch(err => {
        // display error in some way here
        console.error(err);
        this.loadingHasFailed = true;
        this.isLoading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.single-project-wrapper {
  height: 100%;
  overflow-y: scroll;

  .single-project-load-fail-alert {
    max-width: 1400px;
    margin: 0 auto;
    margin-top: 30px;
  }
}
</style>
